module.exports = __webpack_public_path__ + "img/6-6.1a83fdd0.png";